import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import axios from "axios";
import { addmissioncreateApi, addmissionListApi,addmissionupdateApi, addmissiondeleteApi } from "../../../ApiUrl";
export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,
};
// create addmission
export const createaddmission = createAsyncThunk('createaddmission/addmission', async (data, { rejectWithValue }) => {
    try {
        const response = await axios.post(addmissioncreateApi, data, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
export const updateaddmission = createAsyncThunk('updateaddmission/addmission', async ({ data, selectedId }, { rejectWithValue }) => {
    try {
        const response = await axios.put(`${addmissionupdateApi}/${selectedId}`, data, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
// get addmission
export const getaddmission = createAsyncThunk('getaddmission/addmission', async () => {
    try {
        const response = await axios.get(`${addmissionListApi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'addmissions' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete addmission
export const deleteaddmissions = createAsyncThunk('deleteaddmissions/addmission', async (addmissionid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${addmissiondeleteApi}/${addmissionid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'addmissionid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const addmissionSlice = createSlice({
    name: 'addmission',
    initialState: {
        addmissions: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //create addmission
            .addCase(createaddmission.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createaddmission.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(action.payload);
                }
                state.status = 'idle';

            })
            .addCase(createaddmission.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(action.payload);
                }
            })
            //update addmission
            .addCase(updateaddmission.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateaddmission.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(action.payload);
                }
                state.status = 'idle';

            })
            .addCase(updateaddmission.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(action.payload);
                }
            })
            //getaddmissions
            .addCase(getaddmission.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getaddmission.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.addmissions = action.payload;
            })
            .addCase(getaddmission.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete addmissions
            .addCase(deleteaddmissions.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteaddmissions.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.addmissions.data = state.addmissions.data.filter(addmissions => addmissions.addmissionid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deleteaddmissions.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default addmissionSlice.reducer;
